const IconContactSupport = ({ data }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" { ...data }>
		<path d="M11.5 23V19.494C6.49 19.2408 2.5 15.1895 2.5 10.2519C2.5 5.14874 6.76 1 12 1C17.24 1 21.5 5.14874 21.5 10.2519C21.5 15.0726 18.06 19.9225 12.93 22.328L11.5 23ZM12 2.94776C7.86 2.94776 4.5 6.22001 4.5 10.2519C4.5 14.2838 7.86 17.556 12 17.556H13.5V19.7959C17.14 17.556 19.5 13.8747 19.5 10.2519C19.5 6.22001 16.14 2.94776 12 2.94776ZM11 14.1474H13V16.0952H11V14.1474ZM13 12.6866H11C11 9.52147 14 9.76494 14 7.81718C14 6.74591 13.1 5.86941 12 5.86941C10.9 5.86941 10 6.74591 10 7.81718H8C8 5.6649 9.79 3.92165 12 3.92165C14.21 3.92165 16 5.6649 16 7.81718C16 10.2519 13 10.4954 13 12.6866Z" />
	</svg>
)

IconContactSupport.name = 'IconContactSupport'

export { IconContactSupport }
